__turbopack_context__.v({
  "ctaCaption": "widgetform-module-scss-module__srxLPW__ctaCaption",
  "ctaStyles": "widgetform-module-scss-module__srxLPW__ctaStyles",
  "dropdownSelectStyles": "widgetform-module-scss-module__srxLPW__dropdownSelectStyles",
  "duplicationFormError": "widgetform-module-scss-module__srxLPW__duplicationFormError",
  "flexForm": "widgetform-module-scss-module__srxLPW__flexForm",
  "formSectionHeaderStyles": "widgetform-module-scss-module__srxLPW__formSectionHeaderStyles",
  "formSectionTextBlockStyles": "widgetform-module-scss-module__srxLPW__formSectionTextBlockStyles",
  "fullWidth": "widgetform-module-scss-module__srxLPW__fullWidth",
  "halfWidth": "widgetform-module-scss-module__srxLPW__halfWidth",
  "selectorStyles": "widgetform-module-scss-module__srxLPW__selectorStyles",
  "stateContainer": "widgetform-module-scss-module__srxLPW__stateContainer",
  "stateWrapper": "widgetform-module-scss-module__srxLPW__stateWrapper",
  "subheadlineStyles": "widgetform-module-scss-module__srxLPW__subheadlineStyles",
  "submitButtonWrapper": "widgetform-module-scss-module__srxLPW__submitButtonWrapper",
  "submitted": "widgetform-module-scss-module__srxLPW__submitted",
  "successErrorWrapper": "widgetform-module-scss-module__srxLPW__successErrorWrapper",
  "successHeadlineStyles": "widgetform-module-scss-module__srxLPW__successHeadlineStyles",
  "widgetContainer": "widgetform-module-scss-module__srxLPW__widgetContainer",
  "widgetForm": "widgetform-module-scss-module__srxLPW__widgetForm",
  "wrapperRow": "widgetform-module-scss-module__srxLPW__wrapperRow",
  "zipInputStyles": "widgetform-module-scss-module__srxLPW__zipInputStyles",
});
